import styled from '@emotion/styled'
import React from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { useTranslation } from 'react-i18next'
import { useLoaderData } from 'react-router-dom'

import { Button, Grid, LinearProgress, Divider as MuiDivider, Typography } from '@mui/material'

import { spacing } from '@mui/system'
import useAuth from '../../../hooks/useAuth'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import ConvertibleBasicInfo from './ConvertibleBasicInfo'
import InfoBlock from '../../components/InfoBlock'
import ConvertibleEvents from './ConvertibleEvents'
import ConvertibleInvestors from './ConvertibleInvestors'
import ConvertibleOtherInfo from './ConvertibleOtherInfo'

const Divider = styled(MuiDivider)(spacing)

function ConvertibleDetails() {
    const { user } = useAuth()
    const { t } = useTranslation()
    const convertible = useLoaderData() as ConvertibleEntity

    const convertibleName = convertible.convertibleName

    return (
        <>
            <Helmet
                title={t('site.convertibles.detailsTitle', {
                    name: convertibleName,
                })}
            />
            <Typography variant='h3' gutterBottom display='inline'>
                {t('site.convertibles.detailsTitle', { name: convertibleName })}
            </Typography>

            {user?.groups?.includes('superadmin') && (
                <>
                    <Button variant='text' href={`/admin/convertibles/${convertible?.id}`}>
                        [Redigera]
                    </Button>
                </>
            )}

            <Divider my={6} />

            <Grid container spacing={6}>
                <Grid size={12}>
                    {!convertible && <LinearProgress />}
                    {convertible && (
                        <Grid container spacing={6}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <InfoBlock title='Om konvertibellånet'>
                                    <ConvertibleBasicInfo convertible={convertible} />
                                </InfoBlock>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <InfoBlock title='Händelser'>
                                    <ConvertibleEvents convertible={convertible} />
                                </InfoBlock>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <ConvertibleInvestors convertible={convertible} />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <InfoBlock title='Övrigt'>
                                    <ConvertibleOtherInfo convertible={convertible} />
                                </InfoBlock>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    )
}

export default ConvertibleDetails
